import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import ModalWrapper from 'components/Modals/ModalWrapper';
import AddressType from 'components/Customer/CustomerAddressType';

const InputId = {
  line1: 'line1',
  line2: 'line2',
  line3: 'line3',
  line4: 'line4',
  postalCode: 'postalCode',
  country: 'country'
};

const AddCustomerAddressModal = ({
  dispatch,
  addressType,
  isAddAddressModalShown,
  onCancel,
  prevAddresses,
  jurisdictions,
  isPrimary
}) => {
  const [inputAddress, setAddressValues] = useState({
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    postalCode: '',
    country: ''
  });

  const dispatchAddress = () => {
    let addressTypeValue = null;
    let formField = null;
    if (addressType === AddressType.permanent) {
      addressTypeValue = 1;
      formField = 'permanentAddresses';
    }

    if (addressType === AddressType.mailing) {
      addressTypeValue = 2;
      formField = 'mailingAddresses';
    }

    const addressProps = {
      id: 0,
      clientId: 0,
      customerId: 0,
      source: 1,
      addressType: addressTypeValue,
      effectiveFrom: new Date(),
      lastUpdated: new Date(),
      isPrimary,
      regime: 0,
      address: inputAddress,
      isDeleted: false,
    };
    dispatch(change('customerEditForm', formField, [...(prevAddresses || []), addressProps]));
  };

  const onConfirm = (value) => {
    dispatchAddress(value);
    onCancel();
  };

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setAddressValues({ ...inputAddress, [name]: value });
  };

  const modalTitle = addressType === AddressType.permanent ? 'Permanent' : 'Mailing';

  return (
    <ModalWrapper
      headerClose={ false }
      isOpen={ isAddAddressModalShown }
      btnConfirmTitle="Submit"
      btnCancelTitle="Cancel"
      title={ `Add ${ modalTitle } Address` }
      modalSize="edit-address-modal"
      onConfirm={ () => onConfirm(inputAddress) }
      onCancel={ onCancel }
    >
      <form className="form add-customer-address-modal" id="customer-address-modal">
        <div className="columns col-12">
          <div className="col-6 form-group">
            <label id={ `${ InputId.line1 }-label` }>Address Line 1</label>
            <input
              id={ InputId.line1 }
              name={ InputId.line1 }
              className="form-input"
              value={ inputAddress.line1 }
              onChange={ onChangeHandler }
            />
          </div>
          <div className="col-6">
            <label id={ `${ InputId.line2 }-label` }>Address Line 2</label>
            <input
              id={ InputId.line2 }
              name={ InputId.line2 }
              className="form-input"
              value={ inputAddress.line2 }
              onChange={ onChangeHandler }
            />
          </div>
        </div>
        <div className="columns col-12 mt-2">
          <div className="col-6 form-group">
            <label id={ `${ InputId.line3 }-label` }>Address Line 3</label>
            <input
              id={ InputId.line3 }
              name={ InputId.line3 }
              className="form-input"
              value={ inputAddress.line3 }
              onChange={ onChangeHandler }
            />
          </div>
          <div className="col-6">
            <label id={ `${ InputId.line4 }-label` }>Address Line 4</label>
            <input
              id={ InputId.line4 }
              name={ InputId.line4 }
              className="form-input"
              value={ inputAddress.line4 }
              onChange={ onChangeHandler }
            />
          </div>
        </div>
        <div className="columns col-12 mt-2">
          <div className="col-4 form-group">
            <label id={ `${ InputId.postalCode }-label` }>Postal Code</label>
            <input
              id={ InputId.postalCode }
              name={ InputId.postalCode }
              className="form-input"
              value={ inputAddress.postalCode }
              onChange={ onChangeHandler }
            />
          </div>
          <div className="col-8">
            <label id={ `${ InputId.country }-label` }>Country</label>
            <select
              id={ InputId.country }
              name={ InputId.country }
              className="form-select"
              value={ inputAddress.country }
              onChange={ onChangeHandler }
            >
              <option value="">Please select...</option>
              {jurisdictions && jurisdictions.map(x => (
                <option key={ x.name }>{ x.name }</option>
              ))}
            </select>
          </div>
        </div>
      </form>
    </ModalWrapper>
  );
};

AddCustomerAddressModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  addressType: PropTypes.string.isRequired,
  isAddAddressModalShown: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  prevAddresses: PropTypes.arrayOf(PropTypes.shape()),
  jurisdictions: PropTypes.arrayOf(PropTypes.shape()),
  isPrimary: PropTypes.bool
};

AddCustomerAddressModal.defaultProps = {
  isAddAddressModalShown: false,
  prevAddresses: null,
  jurisdictions: null,
  isPrimary: false
};

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapDispatchToProps
)(AddCustomerAddressModal);
